const supplierQuotation = {
  status: 'Status',
  productCode: 'Product Code ',
  productName: 'Product Name ',
  productModel: 'Product Model ',
  productCount: 'Quantity of goods',
  mrd: 'Expected delivery time ',
  deadline: 'The latest submission time',
  mpq: 'Minimum packaging for contracts',
  curMpq: 'Single minimum packaging',
  days: 'Contract supply cycle',
  curDays: 'Single supply cycle',
  price: 'The contract price',
  curPrice: 'Single quotation',
  curTotalPrice: 'Total price per transaction',
  submitTimer: 'Submission countdown',
  operation: 'Operation',
  handlePrice: 'Quotation',
  priceInfo: 'Quotation Information',
  rejected: 'Rejected',
  confirmQuote: 'Are you sure about the quote?',
  confirmQuotaeip: 'This will submit a quote for the product',
};

export default supplierQuotation;